
export default function CTAButtons() {
  return (
    <section className="py-16 px-6 bg-gradient-to-r from-teal-800 via-teal-900 to-teal-800">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6">
          <button className="group bg-white/10 hover:bg-white/20 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-8 transition-all transform hover:scale-105 cursor-pointer">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-white text-2xl"></i>
                </div>
                <span className="text-white text-xl font-bold whitespace-nowrap">Get Visitor Guide</span>
              </div>
              <i className="ri-arrow-right-line text-white text-2xl group-hover:translate-x-2 transition-transform"></i>
            </div>
          </button>

          <button className="group bg-white/10 hover:bg-white/20 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-8 transition-all transform hover:scale-105 cursor-pointer">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-rose-500 rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-white text-2xl"></i>
                </div>
                <span className="text-white text-xl font-bold whitespace-nowrap">Sign up for Updates</span>
              </div>
              <i className="ri-arrow-right-line text-white text-2xl group-hover:translate-x-2 transition-transform"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
